<!--  -->
<template>
  <div class="contentbox">
    <!-- <div class="logo">
        <img src="/static/img/logo21.png" alt="" @click="$router.push('/')">
    </div> -->
    <div class="inqBox">
        <h1>考试中心</h1>
        <input type="text" v-model="loginUser.identificationcard" class="inid" placeholder="证件号码"/>
        <input type="password" v-model="loginUser.password" class="inpass" placeholder="请输入密码"/>
        <p>如果无法登录，请联系组织单位专员</p>
        <button @click="submitForm() ">登陆</button>
    </div>
  </div>
</template>

<script>
import { Message} from "element-ui";
import request from '@/request/http.js';
export default {
  data () {
    return {
        loginUser:{
        }
    };
  },

  mounted(){},

  methods: {
    submitForm() {
      if (!this.loginUser.password) {
        Message.error("密码不能为空！");
        return;
      } else if (!this.loginUser.identificationcard) {
        Message.error("身份证号码不能为空！");
        return;
      }
      //处理业务逻辑
      request.post("/login", this.loginUser).then((res) => {
        window.open(`https://www.cnks.org.cn/?userid=${this.loginUser.identificationcard}&password=${this.loginUser.password}&_t=${Math.random()}`,"_self");
      });

    },
    keyDown(e) {
      //如果是按回车则执行登录方法
      if (e.keyCode == 13) {
        this.submitForm();
      }
    },
  }
}

</script>
<style scoped>
.logo{
    text-align: center;
    position: relative;
    top:120px;
}
.contentbox{
  height: 100%;
    background:url(/static/img/exambg.png);
    background-repeat:no-repeat ;
    background-size: cover;
}
.inqBox{
    position: relative;
    top: 150px;
    width: 522px;
    height: 328px;
    background: rgba(255,255,255,0.3);
    border-radius: 16px 16px 16px 16px;
    opacity: 1;
    margin: auto;
    padding: 19px;
    text-align: center;
}
.inqBox h1{
    font-size: 20px;
    
    font-weight: bold;
    color: #FFFFFF;
    line-height: 23px;
    text-align: center;
}
.inqBox input {
    width: 364px;
    height: 20px;
    background: #F2F2F2;
    background-repeat: no-repeat;
    background-position: 22px 15px;
    border-radius: 8px 8px 8px 8px;
    
    font-size: 16px;
    padding: 14px 10px 14px 53px;
}
.inqBox .inid{
    margin-top: 51px;
    background-image: url(/static/img/cardid.png);
}
.inqBox .inpass{
    margin-top: 28px;
    background-image: url(/static/img/pass.png);
}
.inqBox p{
    font-size: 16px;
    
    font-weight: 400;
    color: #FFFFFF;
    line-height: 19px;
    margin-top: 41px;
    margin-bottom: 13px;
}
.inqBox button{
    width: 427px;
    height: 45px;
    background: #579BF1;
    border-radius: 8px 8px 8px 8px;
    font-size: 24px;
    
    font-weight: normal;
    color: #FFFFFF;
    line-height: 28px;
}
</style>